<template>
  <Modal
    :open="openSuccessModal"
    class="status-modal"
    :hasCloseButton="false"
  >
    <div class="modal-container" :class="[ modalName ]">
      <p class="modal-container__title">{{ modalTitle }}</p>
      <p v-if="modalMessage" class="modal-container__message">{{ modalMessage }}</p>
      <a v-if="hasLink" :href="hasLink" class="modal-container__link">{{ hasLink }}</a>
      <img class="modal-container__image" :src="modalImage" :alt="modalName"/>
      <BaseButton
        :label="buttonLabel"
        btnColor="gold"
        @setAction="closeModal"
      />
    </div>
  </Modal>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
import Modal from '../Modal.vue'
import {mapGetters} from 'vuex'

export default {
  components: {Modal, BaseButton},
  computed: {
    ...mapGetters(['modalName', 'isOpenModal', 'hasLink']),
    openSuccessModal() {
      return this.isOpenModal
    },
    modalImage() {
      if (this.modalName) return require(`../../assets/icons/${this.modalName}.svg`)
      return ''
    },
    modalTitle() {
      if (this.modalName) return this.$t(`general.${this.modalName}`)
      return ''
    },
    buttonLabel() {
      if (this.modalName === 'success') return this.$t('general.great')
      return this.$t('general.gotIt')
    },
    modalMessage() {
      const message = this.$store.getters.modalMessage
      if (this.modalName === 'success') return message
      if (message.errorMessage) {
        if (message.errorMessage.startsWith('No active account')) {
          return 'Не удается войти с указанным логином и паролем. Проверьте правильность их написания, а также активацию учетной записи в почте, указанной при регистрации'
        }
        if (message.errorMessage.startsWith('Authentication credentials were not provided.')) {
          return 'Вам нужно авторизоваться, чтобы посмотреть эту страницу'
        }
        if (message.errorMessage.startsWith('Учетные данные не были предоставлены.')) {
          return 'Вам нужно авторизоваться, чтобы посмотреть эту страницу'
        }
        return message.errorMessage
      }
      if (message.validation_errors) {
        let formattedMessage = ''
        for (let key in message.validation_errors) {
          formattedMessage += `\n${key} -\n`
          for (let item in message.validation_errors[key]) {
            if (message.validation_errors[key][item].length) {
              formattedMessage += `\n${item} ${message.validation_errors[key][item]}\n`
            }
          }
        }
        return formattedMessage
      }
    }
  },

  methods: {
    closeModal() {
      this.$store.dispatch('updateModalStatus', {
        status: false,
        name: '',
        message: '',
        link: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/modals/status_modal.scss';
</style>



// WEBPACK FOOTER //
// src/components/modal/StatusModal.vue